export function Chip({
  label,
  active,
  onClick,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className={active ? "chip active" : "chip"}
      aria-pressed={active}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
